import React from 'react';
import { IDerayahOrderDetails } from '../../../../types/derayah';
import { DerayahCashMovement } from './DerayahCashMovement';
import { DerayahOrderSummary } from './DerayahOrderSummary';
import { DerayahSubOrdersTable } from './DerayahSubOrdersTable';

interface DerayahDetailsProps {
  order: IDerayahOrderDetails;
}

export const DerayahDetails = React.memo(({ order }: DerayahDetailsProps) => (
  <>
    <DerayahOrderSummary order={order} />
    <DerayahSubOrdersTable subOrders={order.subOrders || []} />
    <DerayahCashMovement order={order} />
  </>
));
